//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "../icons";
export default {
  components: {
    Icon
  },
  props: {
    iconName: String,
    tabTitle: String
  },
  data() {
    return {
      selected: false
    };
  },
  watch:{
    selected:function(){
      console.log("检测到变化")
    }
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/TabbarItem.vue